{
  "de": {
    "place1": "Simvastatin",
    "place2": "Clarithromycin",
    "place3": "Übelkeit",
    "place4": "Erbrechen",
    "title": "Allgemeine Nebenwirkungen",
    "label_nodrug": "Geben Sie zuerst Wirkstoffe ein, damit ein zusätzlich erhöhtes Risiko für bestimme Nebenwirkungen erkannt werden kann.",
    "label_norisk": "Kein erhöhtes Risiko für additive Nebenwirkungen erkannt.",
    "table": "---------",
    "frequency": "Häufigkeit",
    "head": "Nebenwirkungen",
    "topis": "Tablellarischer Auszug der häufigsten Nebenwirkungen",
    "plus": "Zeichen (+): Nebenwirkung beschrieben, aber Häufigkeit nicht bekannt",
    "arrows": "Zeichen (↑/↓): Häufigkeit aufgrund der Exposition eher höher/tiefer",
    "siehe": "Siehe auch Kapitel",
    "schwer": "Schwere Nebenwirkungen",
    "empfehlung": "Empfehlung",
    "empf_inc1": "Die Häufigkeit von Übelkeit kann durch die Komedikation von Simvastatin und Clarithromycin erhöht werden.",
    "empf_inc2": "Die Häufigkeit von Übelkeit und Erbrechen ist erhöht, da sowohl für Simvastatin als auch Clarithromycin diese Nebenwirkungen beschrieben sind.",
    "empf_calc": "Die angegebenen kombinierten Häufigkeiten berechnen sich auf Grundlage der einzelnen Häufigkeiten der Wirkstoffe für die jeweilige Nebenwirkung.",
    "empf_auc1": " und die Exposition von Simvastatin stark erhöht ist.",
    "empf_auc2": " und die Exposition von Simvastatin und Clarithromycin stark erhöht ist.",
    "empf_aud1": ", insbesondere da zusätzlich die Exposition von Simvastatin stark erhöht ist.",
    "empf_aud2": ", insbesondere da zusätzlich die Exposition von Simvastatin und Clarithromycin stark erhöht ist.",
    "bewertung": "Bewertung",
    "bew_info1": "Die Nebenwirkungen werden für jeden Wirkstoff mit absteigender Häufigkeit aufgelistet.",
    "bew_info2": "Diese Liste hat keinen Anspruch auf Vollständigkeit.",
    "bew_nebe1": "Simvastatin verursacht als Nebenwirkung Übelkeit.",
    "bew_nebe2": "Simvastatin verursacht als Nebenwirkungen Übelkeit und Erbrechen.",
    "bew_nebeno": "Für Simvastatin liegen uns keine Angaben zum Auftreten von Nebenwirkungen vor.",
    "avoid": "Simvastatin sollte vermieden werden.",
    "alt": "Weitere Nebenwirkungen",
    "aural": "Aurikulär",
    "cardi": "Kardiologisch",
    "derma": "Dermatologisch",
    "gastr": "Gastrointestinal",
    "endoc": "Endokrin",
    "hemat": "Hämatologisch",
    "vascu": "Vaskulär",
    "hepat": "Hepatisch",
    "muscu": "Muskuloskeletal",
    "immun": "Immunologisch",
    "repro": "Reproduktionssystem",
    "ophth": "Opthalmologisch",
    "metab": "Metabolisch",
    "elect": "Elektrolyte",
    "neuro": "Neurologisch",
    "other": "Systemisch",
    "psych": "Psychisch",
    "renal": "Renal",
    "respi": "Respiratorisch"
  },
  "en": {
    "place1": "simvastatin",
    "place2": "clarithromycin",
    "place3": "nausea",
    "place4": "vomiting",
    "title": "General adverse effects",
    "label_nodrug": "First enter active substances so that an additional increased risk of certain side effects can be assessed.",
    "label_norisk": "No increased risk of additive side effects detected.",
    "table": "---------",
    "frequency": "frequency",
    "head": "Side effects",
    "topis": "Tabular extract of the most common side effects",
    "plus": "Sign (+): side effect described, but frequency not known",
    "arrows": "Sign (↑/↓): frequency rather higher/lower due to exposure",
    "siehe": "See also chapter",
    "schwer": "Serious side effects",
    "empfehlung": "Recommendation",
    "empf_inc1": "The co-medication of simvastatin and clarithromycin can increase the incidence of nausea.",
    "empf_inc2": "The frequency of nausea and vomiting is increased as these side effects have been described for both simvastatin and clarithromycin.",
    "empf_calc": "The reported combined frequencies are calculated on the basis of the individual frequencies of the active substances for the respective side effect.",
    "empf_auc1": " and simvastatin exposure is greatly increased.",
    "empf_auc2": " and exposure to simvastatin and clarithromycin is greatly increased.",
    "empf_aud1": ", especially since exposure to simvastatin is also greatly increased.",
    "empf_aud2": ", especially since the exposure to simvastatin and clarithromycin is also greatly increased.",
    "bewertung": "Rating",
    "bew_info1": "The side effects are listed for each active substance in descending order of frequency.",
    "bew_info2": "This list does not claim to be complete.",
    "bew_nebe1": "Simvastatin causes nausea as a side effect.",
    "bew_nebe2": "Simvastatin causes nausea and vomiting as side effects.",
    "bew_nebeno": "We have no information on the occurrence of side effects for simvastatin.",
    "avoid": "Simvastatin should be avoided.",
    "alt": "Other side effects",
    "aural": "Auricular",
    "cardi": "Cardiac",
    "derma": "Dermatological",
    "gastr": "Gastrointestinal",
    "endoc": "Endocrine",
    "hemat": "Hematological",
    "vascu": "Vascular",
    "hepat": "Hepatic",
    "muscu": "Musculoskeletal",
    "immun": "Immunological",
    "repro": "Reproductive system",
    "ophth": "Ophthalmological",
    "metab": "Metabolic",
    "elect": "Electrolytes",
    "neuro": "Neurological",
    "other": "Systemic",
    "psych": "Mental",
    "renal": "Renal",
    "respi": "Respiratory"
  },
  "fr": {
    "place1": "simvastatine",
    "place2": "clarithromycine",
    "place3": "nausée",
    "place4": "vomissements",
    "title": "Effets indésirables généraux",
    "label_nodrug": "Entrez d'abord les substances actives afin qu'un risque accru supplémentaire de certains effets secondaires puisse être évalué.",
    "label_norisk": "Pas de risque accru d'effets secondaires additifs détectés.",
    "table": "---------",
    "frequency": "fréquence",
    "head": "Effets secondaires",
    "topis": "Extrait tabulaire des effets secondaires les plus courants",
    "plus": "Signe (+): effet secondaire décrit, mais fréquence indéterminée",
    "arrows": "Signe (↑/↓) : fréquence plutôt supérieure/inférieure en raison de l'exposition",
    "siehe": "Voir aussi le chapitre",
    "schwer": "Effets secondaires graves",
    "empfehlung": "Recommandations",
    "empf_inc1": "L'association de simvastatine et de clarithromycine peut augmenter les risques des nausées.",
    "empf_inc2": "La fréquence des nausées et des vomissements est augmentée car ces effets secondaires ont été décrits à la fois pour la simvastatine et la clarithromycine.",
    "empf_calc": "Les fréquences combinées et rapportées sont calculées sur la base des fréquences individuelles des substances actives pour l'effet secondaire respectif.",
    "empf_auc1": " et l'exposition à la simvastatine est considérablement augmentée.",
    "empf_auc2": " et l'exposition à la simvastatine et à la clarithromycine est considérablement augmentée.",
    "empf_aud1": ", d'autant plus que l'exposition à la simvastatine est également fortement augmentée.",
    "empf_aud2": ", d'autant plus que l'exposition à la simvastatine et à la clarithromycine est également fortement augmentée.",
    "bewertung": "Classement",
    "bew_info1": "Les effets indésirables sont répertoriés pour chaque substance active par ordre décroissant de fréquence.",
    "bew_info2": "Cette liste ne prétend pas être complète.",
    "bew_nebe1": "La simvastatine provoque des nausées comme effet secondaire.",
    "bew_nebe2": "La simvastatine provoque la nausée et des vomissements comme effets secondaires.",
    "bew_nebeno": "Nous n'avons aucune information sur l'apparition d'effets secondaires concernant la simvastatine.",
    "avoid": "La simvastatine doit être évitée.",
    "alt": "Autres effets secondaires",
    "aural": "Auriculaire",
    "cardi": "Cardiaque",
    "derma": "Dermatologique",
    "gastr": "Gastro-intestinal",
    "endoc": "Endocrinien",
    "hemat": "Hématologique",
    "vascu": "Vasculaire",
    "hepat": "Hépatique",
    "muscu": "Musculo-squelettique",
    "immun": "Immunologique",
    "repro": "Système reproducteur",
    "ophth": "Ophtalmologique",
    "metab": "Métabolique",
    "elect": "Électrolytes",
    "neuro": "Neurologique",
    "other": "Systémique",
    "psych": "Mental",
    "renal": "Rénal",
    "respi": "Respiratoire",
    "": ">Sign positif (+) : effet secondaire décrit, mais fréquence inconnue"
  },
  "it": {
    "place1": "simvastatina",
    "place2": "claritromicina",
    "place3": "nausea",
    "place4": "vomito",
    "title": "Effetti collaterali generali",
    "label_nodrug": "Per calcolare l'aumento del rischio di specifici effetti indesiderati inserire innanzitutto il nome dei principi attivi.",
    "label_norisk": "Nessun ulteriore aumento del rischio di effetti collaterali rilevato.",
    "table": "---------",
    "frequency": "frequenza",
    "head": "Effetti collaterali",
    "topis": "Tabella riassuntiva degli effetti collaterali più comuni",
    "plus": "Segno (+): effetti collaterali definiti, ma frequenza sconosciuta. ",
    "arrows": "Segno  (↑/↓): frequenza rispettivamente alta o bassa in seguito all'esposizione.",
    "siehe": "Vedi anche il capitolo",
    "schwer": "Effetti indesiderati gravi",
    "empfehlung": "Avvertenze",
    "empf_inc1": "La somministrazione contemporanea di simvastatina e claritromicina potrebbe causare un aumento dell'incidenza di nausea.",
    "empf_inc2": "È stato osservato come sia la simvastatina che la claritromicina causano un aumento della frequenza di nausea e vomito.",
    "empf_calc": "Il numero totale di frequenze riportate sono state calcolate sulla base della frequenza individuale di effetti indesiderati causati dai principi attivi. ",
    "empf_auc1": " e l'esposizione alla simvastatina è notevolmente aumentata. ",
    "empf_auc2": " e l'esposizione alla simvastatina e alla claritromicina è notevolmente aumentata.",
    "empf_aud1": ", in particolare dato che l'esposizione alla simvastatina è anche notevolmente aumentata. ",
    "empf_aud2": ", in particolare dato che l'esposizione alla simvastatina e alla claritromicina è anche notevolmente aumentata.",
    "bewertung": "Valutazione",
    "bew_info1": "Gli effetti collaterali di ciascun principio attivo sono stati disposti in ordine decrescente di frequenza. ",
    "bew_info2": "Questo elenco non pretende di essere completo.",
    "bew_nebe1": "La Simvastatina provoca nausea come effetto indesiderato.",
    "bew_nebe2": "La Simvastatina provoca nausea e vomito come effetto indesiderato.",
    "bew_nebeno": "Non ci sono prove sulla comparsa di effetti indesiderati causati dalla Simvastatina.",
    "avoid": "L'uso di Simvastatina dovrebbe essere evitato.",
    "alt": "Altri effetti indesiderati.",
    "aural": "Auricolare",
    "cardi": "Cardiaco",
    "derma": "Dermatologico",
    "gastr": "Gastrointestinale",
    "endoc": "Endocrino",
    "hemat": "Ematologico",
    "vascu": "Vascolare",
    "hepat": "Epatico",
    "muscu": "Muscoloscheletrico",
    "immun": "Immunologico",
    "repro": "Apparato genitale",
    "ophth": "Oftamologico",
    "metab": "Metabolico",
    "elect": "Elettroliti",
    "neuro": "Neurologico",
    "other": "Sistemico",
    "psych": "Mentale",
    "renal": "Renale",
    "respi": "Respiratorio"
  },
  "es": {
    "place1": "simvastatina",
    "place2": "claritromicina",
    "place3": "náusea",
    "place4": "vómitos",
    "title": "Efectos adversos generales",
    "label_nodrug": "En primer lugar, introduzca las sustancias activas para poder evaluar un aumento adicional del riesgo de determinados efectos secundarios.",
    "label_norisk": "No se detectó un mayor riesgo de efectos secundarios adicionales.",
    "table": "---------",
    "frequency": "frecuencia",
    "head": "Efectos secundarios",
    "topis": "Extracto tabular de los efectos secundarios más comunes.",
    "plus": "Signo (+): efecto secundario descrito, pero frecuencia no conocida",
    "arrows": "Signo (↑ / ↓): frecuencia bastante más alta/más baja debido a la exposición",
    "siehe": "Ver también el capítulo",
    "schwer": "Efectos secundarios graves",
    "empfehlung": "Recomendación",
    "empf_inc1": "La medicación concomitante de simvastatina y claritromicina puede aumentar la incidencia de náuseas.",
    "empf_inc2": "La frecuencia de náuseas y vómitos aumenta ya que estos efectos secundarios se han descrito tanto para simvastatina como para claritromicina.",
    "empf_calc": "Las frecuencias combinadas notificadas se calculan sobre la base de las frecuencias individuales de las sustancias activas para el efecto secundario respectivo.",
    "empf_auc1": " y la exposición a simvastatina aumenta considerablemente.",
    "empf_auc2": " y la exposición a simvastatina y claritromicina aumenta considerablemente.",
    "empf_aud1": ", especialmente porque la exposición a simvastatina también aumenta considerablemente.",
    "empf_aud2": ", especialmente porque la exposición a simvastatina y claritromicina también aumenta considerablemente.",
    "bewertung": "Clasificación",
    "bew_info1": "Los efectos secundarios se enumeran para cada principio activo en orden descendente de frecuencia.",
    "bew_info2": "Esta lista no pretende ser exhaustiva.",
    "bew_nebe1": "La simvastatina provoca náuseas como efecto secundario.",
    "bew_nebe2": "La simvastatina provoca náuseas y vómitos como efectos secundarios.",
    "bew_nebeno": "No tenemos información sobre la aparición de efectos secundarios de la simvastatina.",
    "avoid": "Debe evitarse la simvastatina.",
    "alt": "Otros efectos secundarios",
    "aural": "Auricular",
    "cardi": "Cardíaco",
    "derma": "Dermatológico",
    "gastr": "Gastrointestinal",
    "endoc": "Endocrino",
    "hemat": "Hematológico",
    "vascu": "Vascular",
    "hepat": "Hepático",
    "muscu": "Musculoesquelético",
    "immun": "Inmunológico",
    "repro": "Sistema reproductivo",
    "ophth": "Oftalmológico",
    "metab": "Metabólico",
    "elect": "Electrolitos",
    "neuro": "Neurológico",
    "other": "Sistémico",
    "psych": "Mental",
    "renal": "Renal",
    "respi": "Respiratorio"
  },
  "ru": {
    "place1": "симвастатин",
    "place2": "кларитромицин",
    "place3": "тошнота",
    "place4": "рвота",
    "title": "Общие побочные эффекты",
    "label_nodrug": "Сначала введите активные вещества, чтобы можно было оценить дополнительный повышенный риск определенных побочных эффектов.",
    "label_norisk": "Повышенного риска дополнительных побочных эффектов не обнаружено.",
    "table": "---------",
    "frequency": "частота",
    "head": "Побочные эффекты",
    "topis": "Табличный экстракт наиболее частых побочных эффектов",
    "plus": "Знак (+): побочный эффект описан, но частота неизвестна.",
    "arrows": "Знак (↑ / ↓): частота скорее выше / ниже из-за воздействия",
    "siehe": "Также главу",
    "schwer": "Серьезные побочные эффекты",
    "empfehlung": "Рекомендация",
    "empf_inc1": "Совместное лечение симвастатина и кларитромицина может увеличить частоту тошноты.",
    "empf_inc2": "Частота тошноты и рвоты увеличивается, поскольку эти побочные эффекты были описаны как для симвастатина, так и для кларитромицина.",
    "empf_calc": "Сообщенные комбинированные частоты рассчитываются на основе индивидуальных частот активных веществ для соответствующего побочного эффекта.",
    "empf_auc1": " и воздействие симвастатина значительно увеличивается.",
    "empf_auc2": " и воздействие симвастатина и кларитромицина значительно увеличивается.",
    "empf_aud1": ", тем более что воздействие симвастатина также значительно увеличивается.",
    "empf_aud2": ", тем более что воздействие симвастатина и кларитромицина также значительно увеличивается.",
    "bewertung": "Рейтинг",
    "bew_info1": "Побочные эффекты перечислены для каждого активного вещества в порядке убывания частоты.",
    "bew_info2": "Этот список не претендует на полноту.",
    "bew_nebe1": "Симвастатин как побочный эффект вызывает тошноту.",
    "bew_nebe2": "Симвастатин вызывает тошноту и рвоту как побочные эффекты.",
    "bew_nebeno": "У нас нет информации о возникновении побочных эффектов симвастатина.",
    "avoid": "Симвастатина следует избегать.",
    "alt": "Другие побочные эффекты",
    "aural": "Ушной раковины",
    "cardi": "Сердечный",
    "derma": "Дерматологические",
    "gastr": "Желудочно-кишечный тракт",
    "endoc": "Эндокринный",
    "hemat": "Гематологический",
    "vascu": "Сосудистый",
    "hepat": "Печеночный",
    "muscu": "Опорно-двигательного аппарата",
    "immun": "Иммунологические",
    "repro": "Репродуктивная система",
    "ophth": "Офтальмологический",
    "metab": "Метаболический",
    "elect": "Электролиты",
    "neuro": "Неврологический",
    "other": "Системный",
    "psych": "Ментальный",
    "renal": "Почечный",
    "respi": "Респираторный"
  },
  "pt": {
    "place1": "sinvastatina",
    "place2": "claritromicina",
    "place3": "náusea",
    "place4": "vomitando",
    "title": "Efeitos adversos gerais",
    "label_nodrug": "Primeiro insira as substâncias ativas para que um risco aumentado adicional de certos efeitos colaterais possa ser avaliado.",
    "label_norisk": "Nenhum risco aumentado de efeitos colaterais aditivos detectados.",
    "table": "---------",
    "frequency": "frequência",
    "head": "Efeitos colaterais",
    "topis": "Extrato tabular dos efeitos colaterais mais comuns",
    "plus": "Sinal (+): efeito colateral descrito, mas frequência desconhecida",
    "arrows": "Sinal (↑ / ↓): frequência bastante superior / inferior devido à exposição",
    "siehe": "Veja também o capítulo",
    "schwer": "Efeitos colaterais graves",
    "empfehlung": "Recomendação",
    "empf_inc1": "A co-medicação de sinvastatina e claritromicina pode aumentar a incidência de náuseas.",
    "empf_inc2": "A frequência de náuseas e vômitos é aumentada, pois esses efeitos colaterais foram descritos para sinvastatina e claritromicina.",
    "empf_calc": "As frequências combinadas comunicadas são calculadas com base nas frequências individuais das substâncias ativas para o respetivo efeito secundário.",
    "empf_auc1": " e a exposição à sinvastatina é bastante aumentada.",
    "empf_auc2": " e a exposição à sinvastatina e claritromicina é bastante aumentada.",
    "empf_aud1": ", especialmente porque a exposição à sinvastatina também está bastante aumentada.",
    "empf_aud2": ", especialmente porque a exposição à sinvastatina e claritromicina também está bastante aumentada.",
    "bewertung": "Avaliação",
    "bew_info1": "Os efeitos colaterais são listados para cada substância ativa em ordem decrescente de frequência.",
    "bew_info2": "Esta lista não afirma ser completa.",
    "bew_nebe1": "A sinvastatina causa náuseas como efeito colateral.",
    "bew_nebe2": "A sinvastatina causa náuseas e vômitos como efeitos colaterais.",
    "bew_nebeno": "Não temos informações sobre a ocorrência de efeitos colaterais da sinvastatina.",
    "avoid": "A sinvastatina deve ser evitada.",
    "alt": "Outros efeitos colaterais",
    "aural": "Auricular",
    "cardi": "Cardíaco",
    "derma": "Dermatológico",
    "gastr": "Gastrointestinal",
    "endoc": "Endócrino",
    "hemat": "Hematológico",
    "vascu": "Vascular",
    "hepat": "Hepático",
    "muscu": "Musculoesquelético",
    "immun": "Imunológico",
    "repro": "Sistema reprodutivo",
    "ophth": "Oftalmológico",
    "metab": "Metabólico",
    "elect": "Eletrólitos",
    "neuro": "Neurológico",
    "other": "Sistêmico",
    "psych": "Mental",
    "renal": "Renal",
    "respi": "Respiratório"
  },
  "zh": {
    "place1": "辛伐他汀",
    "place2": "克拉霉素",
    "place3": "恶心",
    "place4": "呕吐",
    "title": "一般不良反应",
    "label_nodrug": "首先输入活性物质，以便评估某些副作用的额外风险。",
    "label_norisk": "未检测到附加副作用的风险增加。",
    "table": "---------",
    "frequency": "频率",
    "head": "副作用",
    "topis": "最常见副作用的表格摘录",
    "plus": "符号 (+)：描述了副作用，但频率未知",
    "arrows": "符号 (↑/↓)：由于接触频率较高/较低",
    "siehe": "另见章节",
    "schwer": "严重的副作用",
    "empfehlung": "推荐",
    "empf_inc1": "辛伐他汀和克拉霉素合用会增加恶心的发生率。",
    "empf_inc2": "恶心和呕吐的频率增加，因为辛伐他汀和克拉霉素都有这些副作用。",
    "empf_calc": "报告的组合频率是根据活性物质对相应副作用的单独频率计算的。",
    "empf_auc1": "并且辛伐他汀的暴露量大大增加。",
    "empf_auc2": "辛伐他汀和克拉霉素的暴露量大大增加。",
    "empf_aud1": "，特别是因为辛伐他汀的暴露也大大增加。",
    "empf_aud2": "，特别是因为辛伐他汀和克拉霉素的暴露也大大增加。",
    "bewertung": "评分",
    "bew_info1": "每种活性物质的副作用按频率降序列出。",
    "bew_info2": "此列表并不声称是完整的。",
    "bew_nebe1": "辛伐他汀会引起恶心作为副作用。",
    "bew_nebe2": "辛伐他汀会引起恶心和呕吐作为副作用。",
    "bew_nebeno": "我们没有关于辛伐他汀副作用发生的信息。",
    "avoid": "应避免使用辛伐他汀。",
    "alt": "其他副作用",
    "aural": "耳廓",
    "cardi": "心脏",
    "derma": "皮肤",
    "gastr": "胃肠道",
    "endoc": "内分泌",
    "hemat": "血液学",
    "vascu": "血管",
    "hepat": "肝",
    "muscu": "肌肉骨骼",
    "immun": "免疫学",
    "repro": "生殖系统",
    "ophth": "眼科",
    "metab": "新陈代谢",
    "elect": "电解质",
    "neuro": "神经病学",
    "other": "系统性",
    "psych": "精神的",
    "renal": "肾",
    "respi": "呼吸系统"
  },
  "ar": {
    "place1": "سيمفاستاتين",
    "place2": "كلاريثروميسين",
    "place3": "غثيان",
    "place4": "التقيؤ",
    "title": "الآثار السلبية العامة",
    "label_nodrug": "أدخل أولاً المواد الفعالة بحيث يمكن تقييم خطر إضافي إضافي لحدوث آثار جانبية معينة.",
    "label_norisk": "لم يتم الكشف عن زيادة خطر الآثار الجانبية المضافة.",
    "table": "---------",
    "frequency": "تردد",
    "head": "آثار جانبية",
    "topis": "مستخلص جدولي من الآثار الجانبية الأكثر شيوعًا",
    "plus": "الإشارة (+): موصوفة أثر جانبي ، لكن شيوعها غير معروف",
    "arrows": "علامة (↑ / ↓): التردد أعلى / أقل إلى حد ما بسبب التعرض",
    "siehe": "انظر أيضا الفصل",
    "schwer": "أعراض جانبية خطيرة",
    "empfehlung": "توصية",
    "empf_inc1": "يمكن أن يزيد الدواء المشترك لسيمفاستاتين وكلاريثروميسين من حدوث الغثيان.",
    "empf_inc2": "يزداد تواتر الغثيان والقيء حيث تم وصف هذه الآثار الجانبية لكل من سيمفاستاتين وكلاريثروميسين.",
    "empf_calc": "يتم حساب الترددات المجمعة المبلغ عنها على أساس الترددات الفردية للمواد الفعالة للتأثير الجانبي ذي الصلة.",
    "empf_auc1": " ويزداد التعرض للسيمفاستاتين بشكل كبير.",
    "empf_auc2": " ويزداد التعرض لسيمفاستاتين وكلاريثروميسين بشكل كبير.",
    "empf_aud1": "، خاصة وأن التعرض لسيمفاستاتين يزداد أيضًا بشكل كبير.",
    "empf_aud2": "، خاصة وأن التعرض لسيمفاستاتين وكلاريثروميسين يزداد أيضًا بشكل كبير.",
    "bewertung": "تقييم",
    "bew_info1": "يتم سرد الآثار الجانبية لكل مادة فعالة بترتيب تنازلي من حيث التردد.",
    "bew_info2": "هذه القائمة لا تدعي أنها كاملة.",
    "bew_nebe1": "يسبب Simvastatin الغثيان كأثر جانبي.",
    "bew_nebe2": "يسبب Simvastatin الغثيان والقيء كآثار جانبية.",
    "bew_nebeno": "ليس لدينا معلومات عن حدوث آثار جانبية لسيمفاستاتين.",
    "avoid": "يجب تجنب Simvastatin.",
    "alt": "أعراض جانبية أخرى",
    "aural": "سمعي",
    "cardi": "عضلات قلبية",
    "derma": "الجلدية",
    "gastr": "الجهاز الهضمي",
    "endoc": "الغدد الصماء",
    "hemat": "أمراض الدم",
    "vascu": "الأوعية الدموية",
    "hepat": "كبدي",
    "muscu": "الجهاز العضلي الهيكلي",
    "immun": "مناعي",
    "repro": "الجهاز التناسلي",
    "ophth": "طب وجراحة العيون",
    "metab": "الأيض",
    "elect": "الشوارد",
    "neuro": "العصبية",
    "other": "النظامية",
    "psych": "عقلي",
    "renal": "كلوي",
    "respi": "تنفسي"
  }
}